const FooterZhCN = {
    messageUs: "给我们留言",
    callUs: "致电我们",
    aboutUs: "关于我们",
    service: "服务",
    eventNew: "活动 & 消息",
    contactUs: "联络我们",
    btn_get_in_touch: "联络我们",
    btn_company_info: "公司资讯",
    btn_company_vision: "公司愿景",
    btn_our_service: "我们的服务",
    btn_news_event: "公司新闻与活动",
}

export default FooterZhCN;